const pkg = require('../../package.json');
const Footer = () => {

    return (
        <div className="mt-2 footer">
            <div className="footerContainer">
                <p style={{ marginBottom: "3px", fontSize: "11px" }}> Powered By Bihamta </p>
                <p style={{ marginBottom: "3px", fontSize: "11px" }}> تهیه و تولید از شرکت هورماه </p>
                <p style={{ fontSize: "11px" }}>نسخه نرم افزار: {pkg.version}</p>
            </div>
        </div>
    )

}

export default Footer;